import {ClassName} from '#/utils/utils';
import {ExclamationTriangleIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, ReactNode} from 'react';

export const WarningMessageAction: FunctionComponent<
  {
    IconComponent?: FunctionComponent<ClassName>;
    iconStrokeClassName?: `stroke-${string}`;
    message: ReactNode;
    buttonContent?: ReactNode;
    action?: () => void;
  } & ClassName
> = ({
  className = '',
  IconComponent = ExclamationTriangleIcon,
  iconStrokeClassName = 'stroke-yellowNotice',
  message,
  buttonContent,
  action,
}) => {
  return (
    <div className={`w-full flex flex-col gap-1 justify-center items-center ${className}`}>
      <IconComponent className={`block w-12 h-12 fill-transparent ${iconStrokeClassName}`} />
      <span className='block text-center text-white font-semibold max-w-[320px]'>{message}</span>
      {buttonContent && action && (
        <button
          className='flex items-center gap-2 px-3 py-2 rounded-xl bg-deepblue shadow-2xl whitespace-nowrap mt-2'
          onClick={action}
        >
          {buttonContent}
        </button>
      )}
    </div>
  );
};
